module.exports = "/dist/montserrat-latin-900.svg?8431076a8c6d3b549562f31d47db154a";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-900.svg
// module id = 82
// module chunks = 0